module.exports = __webpack_public_path__ + "static/media/kliksekolah.3233ecf6.png";